import React, { useState } from 'react';
import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import {
    Dropzone,
    FileMosaic,
    FullScreen,
    ImagePreview,
} from '@dropzone-ui/react';

type Props = {
    name: string;
    accept?: string | undefined;
    maxFiles?: number | undefined;
    onChange: (event: any) => void;
    /** Archivo nativo para armar multipart sin depender solo de FormData interno */
    onFileSelected?: (file: File | null) => void;
};

const DropZoneField = ({
    name,
    accept,
    maxFiles,
    onChange,
    onFileSelected,
}: Props) => {
    //onChange Formik
    //The variable dropzoneFieldFormik must be equal to the variable name of the formik
    //onChange={(value) => formik.setFieldValue('dropzoneFieldFormik', value)}

    const [files, setFiles] = useState<{ id: number; file: any }[]>([]);
    const [imageSrc, setImageSrc] = useState<any>(undefined);

    const buildFormDataList = (incommingFiles: any[]) => {
        const filesObjects: any[] = [];
        if (incommingFiles.length > 0) {
            for (let i = 0; i < incommingFiles.length; i++) {
                const { file } = incommingFiles[i];
                const formdata = new FormData();
                formdata.append('file', file);
                filesObjects.push(formdata);
            }
        }
        return filesObjects;
    };

    const updateFiles = (incommingFiles: any) => {
        setFiles(incommingFiles);
        const filesObjects = buildFormDataList(incommingFiles);
        onChange(filesObjects);
        onFileSelected?.(
            incommingFiles.length > 0 ? incommingFiles[0].file : null
        );
    };

    const removeFile = (id: any) => {
        const newFiles = files.filter((x) => x.id !== id);
        setFiles(newFiles);
        const filesObjects = buildFormDataList(newFiles);
        onChange(filesObjects);
        onFileSelected?.(newFiles.length > 0 ? newFiles[0].file : null);
    };

    const handleSee = (imageSource: any) => {
        setImageSrc(imageSource);
    };

    return (
        <>
            <Dropzone
                name={name}
                onChange={updateFiles}
                value={files}
                autoClean={true}
                accept={accept}
                maxFiles={maxFiles}
                localization="ES-es"
                footer={false}
                header={files.length > 0}
            >
                {files.length === 0 && (
                    <Box
                        mt={2}
                        component="span"
                        display="flex"
                        flexDirection="column"
                        justifyContent="center"
                        alignItems="center"
                        sx={{ color: 'primary.main' }}
                    >
                        <Typography component="span">
                            <strong>
                                Arrastre y suelte algunos archivos aquí,
                            </strong>
                        </Typography>
                        <Typography component="span">
                            <strong>
                                o haga clic para seleccionar archivos
                            </strong>
                        </Typography>
                        <Box mt={1}>
                            <Typography component="span">
                                <>
                                    Tipos de archivos aceptados: <br />
                                    {!accept ? (
                                        <strong>
                                            .png, .jpg, .jpeg, .txt, .csv, .doc,
                                            .docx, .xls, .xlsx, .pdf, <br />{' '}
                                            .video, .audio, .rar, .zip
                                        </strong>
                                    ) : (
                                        <strong>{accept}</strong>
                                    )}
                                </>
                            </Typography>
                        </Box>
                        <Box mt={1}>
                            <CloudUploadOutlinedIcon
                                style={{ fontSize: '3.5rem' }}
                                color="primary"
                            />
                        </Box>
                    </Box>
                )}
                {files.length > 0 &&
                    files.map((file: any) => (
                        <FileMosaic
                            {...file}
                            onDelete={removeFile}
                            key={file.id}
                            info
                            preview
                            resultOnTooltip
                            alwaysActive
                            onSee={handleSee}
                        />
                    ))}
            </Dropzone>
            <FullScreen
                open={imageSrc !== undefined}
                onClose={() => setImageSrc(undefined)}
            >
                <ImagePreview src={imageSrc} />
            </FullScreen>
        </>
    );
};

export default DropZoneField;
